export default "__VITE_ASSET__9124411a__"